import React from 'react';

import {DNAAlignmentKind} from 'constants/AlignmentConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export interface RealignButtonProps {
  alignmentType: DNAAlignmentKind;
  allowFeatureEdits: boolean;
  allowResidueEdits: boolean;
  loaded: boolean;
  openRealignModal: () => void;
}

export default function RealignButton({
  alignmentType,
  allowFeatureEdits,
  allowResidueEdits,
  loaded,
  openRealignModal,
}: RealignButtonProps): JSX.Element {
  const realignEnabled =
    loaded && (alignmentType === DNAAlignmentKind.CONSENSUS ? allowResidueEdits : allowFeatureEdits);
  return (
    <Button
      buttonStyle={ButtonStyle.SECONDARY}
      size={ButtonSize.MINI}
      className="realign"
      onClick={() => {
        openRealignModal();
      }}
      disabled={!realignEnabled}
      text="Realign"
      dataTestAttrs={{component: 'AlignmentTabMenu', element: 'realignButton'}}
    />
  );
}
